import { Modal } from "antd";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleModalZoom } from "store/actionReducers/ModalCommonStore";
import PropertyTrendsModal from "./ModalViewZoom/PropertyTrendsModal";
import './ModalViewZoom.scss'
import MarketReview1Modal from "./ModalViewZoom/MarketReview1Modal";

export default function ModalViewZoom() {
  const dispatch = useDispatch();
  const modalCommon = useSelector((state: any) => state?.ModalCommonStore);
  const modalZoom = modalCommon?.modalZoom;

  const handleOk = () => {
    dispatch(toggleModalZoom(''))
  };

  const handleCancel = () => {
    dispatch(toggleModalZoom(''))
  };
  return (
    <>
      <Modal title="" className="qhxafdkftt" centered footer={false} width={720}
        closable={false}
        visible={modalZoom?.show} onOk={handleOk} onCancel={handleCancel}>
        <div className='qubxfbmyhm'>
          {modalZoom?.typeView === 'PropertyTrends' ? <PropertyTrendsModal /> : null}
          {modalZoom?.typeView === 'MarketReview1' ? <MarketReview1Modal /> : null}
          {modalZoom?.typeView === 'MarketReview2' ? <PropertyTrendsModal /> : null}
          {modalZoom?.typeView === '1' ? <PropertyTrendsModal /> : null}
        </div>
      </Modal>
    </>
  )
}